module.exports = __webpack_public_path__ + "img/ng_fluent_polygon_20_regular.210a35f9.svg";